/*
defines appearance of links
*/

/**
 * represents the view of a link
 */
export default class LinkView {
    /**
     * makes a new link view given a model link and two nodeviews
     *
     * Note: does not take node IDs, takes node objects.
     * this is in order to update its position relative to the nodes
     *
     * @param {Link} link
     * @param {NodeView} source
     * @param {NodeView} target
     */
    constructor(link, source, target) {
        this.link = link;
        this.source = source;
        this.target = target;
        this.id = this.link.id;
        this.strength = this.link.strength;
        this.distance = this.link.distance;
        this.type = this.link.type || '';
        this._hidden = false;
        try {
            console.log(`new link view ${this.id}
                    between ${this.source.type} ${this.source.id}
                    and ${this.target.type} ${this.target.id}`);
        } catch (e) {
            console.error(e);
            console.error(this);
        }
    }


    /**
     * initialize the links given some data
     * @param {Array<LinkView>} links
     */
    static init(links) {
        LinkView.container = d3.select('.everything');

        LinkView.g_selection = LinkView.container.selectAll('.glink')
            .data(links)
            .enter()
            .append('g')
            .attr('class', (linkView) => `glink glink--${linkView.id}`);

        LinkView.linkSelection = LinkView.g_selection
            .append('line');

        LinkView.transparentLineSelection = LinkView.g_selection
            .append('line');

        LinkView.infoSelection = LinkView.g_selection
            .append('text');

        LinkView.style('linkSelection', LinkView.linkSelection);
        LinkView.style('transparentLineSelection', LinkView.transparentLineSelection);
        LinkView.style('infoSelection', LinkView.infoSelection);

        LinkView.inputBoxContainerSelection = d3.select('.link-box');
        LinkView.inputBoxSelection = d3.select('.link-box .box__input');
    }

    /**
     * attribute styles/ additional attributes the links
     * @param {String} selectionName
     * @param {Selection} selection d3 selection
     */
    static style(selectionName, selection) {
        if (selectionName === 'linkSelection') {
            selection
                    .attr('class', (linkView) => `link link-${linkView.id} testing-true`);
                    // .append('svg:title').text((linkView) => linkView.type);
        } else if (selectionName === 'transparentLineSelection') {
            selection
                    .attr('class', (linkView) => `link-transparent link-transparent-${linkView.id}`);
        } else if (selectionName === 'infoSelection') {
            selection
                    .text((linkView) => linkView.type)
                    .attr('class', (linkView) => `link-info link-info-${linkView.id}`);
        }
    }

    /**
     * when links are changed, update the D3 elements to match the data
     * i.e., add or remove new lines
     * @param {Array<LinkView>} links
     */
    static restart(links) {
        console.log('number of links', links.length);
        LinkView.g_selection = LinkView.g_selection.data(links);
        LinkView.g_selection.exit().remove();
        let newGLinks = LinkView.g_selection
                                .enter().append('g')
                                .attr('class', (linkView) => `glink glink--${linkView.id}`);

        LinkView.style('linkSelection', newGLinks.append('line'));
        LinkView.style('transparentLineSelection', newGLinks.append('line'));
        LinkView.style('infoSelection', newGLinks.append('text'));

        // update selection
        LinkView.g_selection = newGLinks.merge(LinkView.g_selection);
        LinkView.linkSelection = LinkView.g_selection.selectAll('.link');
        LinkView.transparentLineSelection = LinkView.g_selection.selectAll('.link-transparent');
        LinkView.infoSelection = LinkView.g_selection.selectAll('.link-info');
    }
    /**
     * updates the position of links on each frame
     */
    static onTick() {
        LinkView.linkSelection
                .attr('x1', (d) => d.source.x)
                .attr('y1', (d) => d.source.y)
                .attr('x2', (d) => d.target.x)
                .attr('y2', (d) => d.target.y)
                .classed('off', (d) => !!d._hidden);
        LinkView.infoSelection
                .attr('x', (d) => d.x)
                .attr('y', (d) => d.y)
                .text((d) => d.type);
        LinkView.transparentLineSelection
            .attr('x1', (d) => d.source.x)
            .attr('y1', (d) => d.source.y)
            .attr('x2', (d) => d.target.x)
            .attr('y2', (d) => d.target.y);

        LinkView.updateInputBoxPosition();
    }

    /**
     * updates the position of the input box to be centered in the link
     */
    static updateInputBoxPosition() {
        if (LinkView.isBoxShown()) {
            let selections = ['linkSelection', 'infoSelection', 'transparentLineSelection'];

            for (let i = 0; i < selections.length; i++) {
                LinkView[selections[i]].attr('data-input', (d) => {
                    let box = LinkView.inputBoxContainerSelection;
                    if (d.id == parseInt(box.attr('data-link'))) {
                        box.attr('x', d.x).attr('y', d.y);
                    }
                    return '';
                });
            }
        }
    }

    /**
     *
     */
    get x() {
        return Math.floor((this.source.x + this.target.x)/2);
    }

    /**
     *
     */
    get y() {
        return Math.floor((this.source.y + this.target.y)/2);
    }

    /**
     *
     */
    showBox() {
        LinkView.inputBoxContainerSelection
            .attr('data-link', this.id)
            .classed('on connect-on', true)
            .attr('x', (this.x - 25))
            .attr('y', this.y);
    }

    /**
     *
     */
    hideBox() {
        LinkView.inputBoxContainerSelection
        .classed('on connect-on', false);
    }

    /**
     *
     */
    static isBoxShown() {
        return LinkView.inputBoxContainerSelection.classed('connect-on');
    }

    /**
     * increases the opacity of this link
     */
    reinforceLink(strength = 1) {
        // this.getSelection();
        // this.linkSelection
        //     .style('stroke-opacity',
        //             _.toNumber(this.linkSelection.style('stroke-opacity')) + .1 * strength);
    }

    resetForce() {
        this.distance = this.link.distance;
        this.strength = this.link.strength;
    }

    hide() {
        this._hidden = true;
        // this.getSelection();
        // this.selection.classed('off', true);
    }

    show() {
        this._hidden = false;
        // this.getSelection();
        // this.selection.classed('off', false);
    }

    getSelection() {
        return this.linkSelection = (!this.linkSelection || this.linkSelection.empty()) ? d3.select(`.link-${this.id}`) : this.linkSelection;
    }
}
